export function getGraphPoints(
	prices: number[],
	width: number,
	height: number,
) {
	if (prices.length !== 4) return [];
	const min = Math.min(...prices);
	const max = Math.max(...prices);

	const xCoords = [35, 75, 171, 203];
	const yPadding = 20;
	const yMin = yPadding;
	const yMax = height - yPadding;

	// Нормализация цен
	const points = prices.map((price, i) => {
		const normY = max === min ? 0.5 : (price - min) / (max - min);
		const y = yMax - normY * (yMax - yMin);
		return {
			x: xCoords[i],
			y,
			value: price,
		};
	});

	points.unshift({ x: 0, y: points[0].y, value: prices[0] });
	points.push({ x: width, y: points[points.length - 1].y, value: prices[3] });

	return points;
}
